"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var components_1 = require("../components");
var NumberField_1 = __importDefault(require("./NumberField"));
var NumberRangeField = function (_a) {
    var fromLabel = _a.fromLabel, fromName = _a.fromName, toLabel = _a.toLabel, toName = _a.toName, className = _a.className, toolTipFrom = _a.toolTipFrom, toolTipTo = _a.toolTipTo, defValueOd = _a.defValueOd, defValueDo = _a.defValueDo;
    return (react_1.default.createElement(components_1.Field, { noStyles: true },
        react_1.default.createElement("div", { className: className },
            react_1.default.createElement(NumberField_1.default, { label: fromLabel, name: fromName, maxWidth: true, toolTip: toolTipFrom, defValue: defValueOd }),
            react_1.default.createElement(NumberField_1.default, { label: toLabel, name: toName, maxWidth: true, toolTip: toolTipTo, defValue: defValueDo }))));
};
NumberRangeField.defaultProps = {
    className: undefined,
    toolTipFrom: undefined,
    toolTipTo: undefined,
    defValueOd: undefined,
    defValueDo: undefined,
};
exports.default = styled_components_1.default(NumberRangeField)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
